import type { ConditionalRuleDto } from "@babackapp/private-api-client/types";

export type FieldType = ConditionalRuleDto["type"]; // "ARRAY" | "NUMBER" | "STRING" | "BOOLEAN"

export type OperatorOption = {
  value: ConditionalRuleDto["operator"];
  supportedTypes: FieldType[];
};

export type FieldIdDefinition =
  | "orderTotalAmount"
  | "orderTags"
  | "orderCreatedAt"
  | "orderItemCount"
  | "productTags"
  | "returnReasonIds"
  | "returnCreatedAt"
  | "returnItemCount"
  | "returnItemResolutions"
  | "customerShippingCountryCode"
  | "customerShippingCity"
  | "customerTags"
  | "customerMetafields"
  | "customerReturnCountLast12Months";

export type FieldDefinition = {
  id: FieldIdDefinition;
  type: FieldType;
};

export type FieldOptionsDefinition = {
  id: string;
  options: string[];
};

export const OPERATORS: OperatorOption[] = [
  { value: "EQ", supportedTypes: ["STRING", "NUMBER", "DATE", "BOOLEAN"] },
  { value: "NE", supportedTypes: ["STRING", "NUMBER", "DATE", "BOOLEAN"] },
  { value: "GT", supportedTypes: ["NUMBER", "DATE"] },
  { value: "GTE", supportedTypes: ["NUMBER", "DATE"] },
  { value: "LT", supportedTypes: ["NUMBER", "DATE"] },
  { value: "LTE", supportedTypes: ["NUMBER", "DATE"] },
  { value: "IN", supportedTypes: ["STRING"] },
  { value: "NOT_IN", supportedTypes: ["STRING"] },
  { value: "BETWEEN", supportedTypes: ["NUMBER", "DATE"] },
  { value: "CONTAINS", supportedTypes: ["STRING", "ARRAY"] },
  { value: "NOT_CONTAINS", supportedTypes: ["STRING", "ARRAY"] },
  { value: "HAS_KEY_VALUE", supportedTypes: ["KEY_VALUE_ARRAY"] },
  { value: "NOT_HAS_KEY_VALUE", supportedTypes: ["KEY_VALUE_ARRAY"] },
];

export const FIELD_DEFINITIONS: FieldDefinition[] = [
  { id: "orderTotalAmount", type: "NUMBER" },
  { id: "orderTags", type: "ARRAY" },
  { id: "orderCreatedAt", type: "DATE" },
  { id: "orderItemCount", type: "NUMBER" },

  { id: "productTags", type: "ARRAY" },

  { id: "returnReasonIds", type: "ARRAY" },
  { id: "returnCreatedAt", type: "DATE" },
  { id: "returnItemCount", type: "NUMBER" },
  { id: "returnItemResolutions", type: "ARRAY" },

  { id: "customerShippingCountryCode", type: "STRING" },
  { id: "customerShippingCity", type: "STRING" },
  { id: "customerTags", type: "ARRAY" },
  { id: "customerMetafields", type: "KEY_VALUE_ARRAY" },
  { id: "customerReturnCountLast12Months", type: "NUMBER" },
];
export const FIELD_OPTIONS_DEFINITIONS: FieldOptionsDefinition[] = [
  {
    id: "returnItemResolutions",
    options: [
      "refund",
      "exchange",
      "exchange-credit",
      "discount",
      "new-articles",
    ],
  },
];
export const getAvailableOperators = (
  fieldType: FieldType,
): OperatorOption[] => {
  return OPERATORS.filter((op) => op.supportedTypes.includes(fieldType));
};

export const getFieldById = (id: string): FieldDefinition | undefined => {
  return FIELD_DEFINITIONS.find((field) => field.id === id);
};

export const getFieldOptionsById = (
  id: string,
): FieldOptionsDefinition | undefined => {
  return FIELD_OPTIONS_DEFINITIONS.find(
    (fieldOptions) => fieldOptions.id === id,
  );
};
